import { render } from "./ProspectIndustries.vue?vue&type=template&id=36a2a065"
import script from "./ProspectIndustries.vue?vue&type=script&lang=js"
export * from "./ProspectIndustries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__